module.exports = __webpack_public_path__ + "static/media/logo.8cfa69c0.svg";